<div class="drag-handle" #dragHandle cdkDragHandle>
  <div class="drag-handle-image"></div>
</div>
<div class="buttons-container">
  <ng-content></ng-content>
  @let isVideoSlide = isVideoSlide$ | async;
  @let isVideoStarted = isVideoStarted$ | async;
  <div
    class="play-button"
    [ngClass]="{hidden: !isVideoSlide }"
    >
      @if (!isVideoStarted) {
        <button
          (click)="videoStart()"
          class="play"
          mat-button mat-raised-button
          >
          <mat-icon>play_circle</mat-icon>
        </button>
      }
      @if (isVideoStarted) {
        <button
          (click)="videoPause()"
          class="pause"
          mat-button mat-raised-button
          color="primary"
          >
          <mat-icon>pause_circle</mat-icon>
        </button>
      }
  </div>
</div>
<button class="close-icon-button" mat-icon-button (click)="onHideFloatingToolbar()">
  <mat-icon fontIcon="close" [inline]="true"></mat-icon>
</button>